// qualificationAnalytics.js — BL-017 Story 17.5
//
// Thin, declarative wrappers over lib/analytics.track for the Opportunity
// Qualification funnel. Centralizing the event names here keeps call sites
// clean and locks the contract under test. track() already injects the
// BL-025 `environment` super-property/tag, so these events are environment-safe.

import { track } from './analytics';

export function qualificationStarted(props = {}) {
  track('qualification_started', props);
}

export function qualificationCompleted(props = {}) {
  track('qualification_completed', props);
}

// Maps the triage verdict to its dedicated funnel event.
const VERDICT_EVENT = {
  Pursue: 'qualification_pursue',
  Investigate: 'qualification_investigate',
  Reject: 'qualification_reject',
};

export function qualificationVerdictEvent(recommendation, props = {}) {
  const event = VERDICT_EVENT[recommendation];
  if (event) track(event, props);
}

export function qualificationToDealAnalyzer(props = {}) {
  track('qualification_to_deal_analyzer', props);
}

// Required properties: original_verdict, score_band, regulatory_state.
export function qualificationOverride(props = {}) {
  track('qualification_override', props);
}
